import { track } from "../analytics";
import type { Channel, SoundMode } from "@gooner/shared";

/*
 * The audio panel's closed vocabularies.
 *
 * analytics.ts keeps the NAME union; these wrappers close the PROPS at compile time — the
 * lib/gold.ts pattern, and the reason a prop cannot quietly widen from a curated id into a
 * channel's name, an artist's name, or a url. Every value that leaves here is either a slug
 * we wrote or a member of a three-item enum.
 *
 * Kept OUT of lib/api.ts on purpose: analytics-scrub asserts that no api-client track call
 * carries a prop matching /id\b/, and `{ channel: … }` would trip it. These belong beside
 * the vocabulary they close, not beside the transport.
 */

export const trackAudioPanel = (): void => track("audio_panel_opened");

export const trackAudioMode = (mode: SoundMode): void => track("audio_mode_set", { mode });

/** The level a hand LEFT the fader at, 0-100 — once per drag, at its settle. A number,
 *  never a word, and never every frame of the drag. */
export const trackMasterVolume = (level: number): void =>
  track("master_volume_set", { level: Math.round(level * 100) });

/** The channel's own fader, same settle rule as the master's. */
export const trackChannelVolume = (level: number): void =>
  track("channel_volume_set", { level: Math.round(level * 100) });

/** A channel started. The ids only — the name and the artist stay here. */
export const trackChannelPlayed = (channel: Channel): void =>
  track("channel_played", { channel: channel.id, partner: channel.partner.id });
